/// <amd-module name="Build/Admin/Agent/Sources/AgentSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { TaskAgent } from "DistributedTask/Client/Contracts/TaskAgent";
import { getTaskAgentClient, ITaskAgentRestClient } from "DistributedTask/Client/RestClient/TaskAgent";

import { TaskAgentData } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { DataProviders } from "Build/Admin/Common/Constants";

export class AgentSource {
    private _agentData: TaskAgentData | undefined;
    private _client: ITaskAgentRestClient;

    constructor(pageContext: IVssPageContext) {
        const contributionService: IVssContributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        this._agentData = contributionService.getData<TaskAgentData>(DataProviders.Agent);
        this._client = getTaskAgentClient(pageContext);
    }

    public getCachedAgentData(): TaskAgentData | undefined {
        return this._agentData;
    }

    public async updateAgentUserCapabilities(poolId: number, agentId: number, userCapabilities: { [key: string ]: string }): Promise<TaskAgent> {
        return this._client.updateAgentUserCapabilities(userCapabilities, poolId, agentId);
    }
}
